<template>
  <v-row align="center" justify="center">
    <v-col cols="12" lg="10">
      <v-card shaped>
        <v-card-title>
          <v-icon large left color="primary">mdi-clock-check-outline</v-icon>
          <span class="title font-weight-light">Отчет по актуальности прайсов</span>
          <v-spacer></v-spacer>
          <v-chip class="mx-1" small color="red lighten-4">Скрытый поставщик</v-chip>
          <v-chip class="mx-1" small color="orange lighten-4">Прайс старше 7 дней</v-chip>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :items-per-page="-1"
          hide-default-footer
          dense
        >
          <template v-slot:item="{ item, index }">
            <tr :style="item.isHidden ? 'background-color: #FFCDD2' : ''">
              <td>{{ index + 1 }}</td>
              <td>{{ ShowDistributorName(index) ? item.distributorName : "" }}</td>
              <td>{{ item.filialName }}</td>
              <td>{{ item.cityName }}</td>
              <td>
                <v-chip small :color="item.isActual ? 'transparent' : 'orange lighten-4'">
                  {{ FormatDate(item.lastPriceDate) }}
                </v-chip>
              </td>
              <td>
                <v-btn small color="primary" outlined @click="LookPrices(item)">
                  Посмотреть прайсы
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    items: [],
    loading: false,
    headers: [
      { text: "№", sortable: false },
      { text: "Дистрибьютор", value: "distributorName", sortable: false },
      { text: "Филиал", value: "filialName", sortable: false },
      { text: "Город", value: "cityName", sortable: false },
      { text: "Дата прайса филиала", value: "lastPriceDate", sortable: false },
      { text: "", sortable: false },
    ],
  }),
  mounted() {
    this.GetReport();
  },
  methods: {
    async GetReport() {
      this.loading = true;
      try {
        this.items = await this.$store.dispatch("FILIALS_PRICE_ACTUALITY");
      } catch (error) {
        window.console.log(error);
      } finally {
        this.loading = false;
      }
    },
    ShowDistributorName(index) {
      return (
        index === 0 ||
        this.items[index].distributorId !== this.items[index - 1].distributorId
      );
    },
    FormatDate(value) {
      const date = new Date(value);
      const pad = (num) => (num < 10 ? "0" + num : num);
      return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    LookPrices(item) {
      this.$store.commit("SET_SELECTED_FILIALS_IN_PRICES", [item.filialId]);
      this.$router.push({ path: "/order" });
    },
  },
};
</script>
